
import { useEffect } from "react";
import { motion } from "framer-motion";
import { Package, Shield, Heart } from "lucide-react";

export default function PackagingPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-grow pt-24 pb-24">
        <div className="container mx-auto px-4 py-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-4xl mx-auto"
          >
            <h1 className="text-4xl md:text-5xl font-bold font-playfair mb-8">Packaging</h1>
            <div className="prose max-w-none space-y-6 text-gray-700">
              <p>
                At Aarsa, we take great care in packaging your jewellery to ensure it arrives in perfect
                condition. Our packaging is designed to protect your precious pieces while also providing
                an elegant unboxing experience.
              </p>
              <div className="grid md:grid-cols-3 gap-6 my-8">
                <div className="bg-aarsa-sage-50 rounded-lg p-6">
                  <Package className="w-8 h-8 text-aarsa-sage-600 mb-4" />
                  <h3 className="font-bold text-lg mb-2">Secure Packaging</h3>
                  <p className="text-sm">Multi-layer protection for safe delivery</p>
                </div>
                <div className="bg-aarsa-gold-50 rounded-lg p-6">
                  <Shield className="w-8 h-8 text-aarsa-gold-600 mb-4" />
                  <h3 className="font-bold text-lg mb-2">Elegant Presentation</h3>
                  <p className="text-sm">Beautiful boxes perfect for gifting</p>
                </div>
                <div className="bg-aarsa-cream-100 rounded-lg p-6">
                  <Heart className="w-8 h-8 text-aarsa-sage-600 mb-4" />
                  <h3 className="font-bold text-lg mb-2">Eco-Friendly</h3>
                  <p className="text-sm">Sustainable packaging materials</p>
                </div>
              </div>
              <h2 className="text-3xl font-bold font-playfair mt-8 mb-4">Our Packaging Process</h2>
              <ol className="list-decimal list-inside space-y-2">
                <li>Each piece is carefully wrapped in soft, protective material</li>
                <li>Items are placed in individual pouches or boxes</li>
                <li>Certificates and care instructions are included</li>
                <li>Everything is secured in a sturdy outer box</li>
                <li>Gift wrapping available upon request</li>
              </ol>
              <h2 className="text-3xl font-bold font-playfair mt-8 mb-4">Gift Packaging</h2>
              <p>
                Make your purchase extra special with our elegant gift packaging option. Perfect for
                birthdays, anniversaries, or any special occasion.
              </p>
            </div>
          </motion.div>
        </div>
      </main>
    </div>
  );
}
